
  <!-- used to trick browsers into autofilling these inputs instead of the actual username and password inputs -->
  <input
  style="display: none"
  type="password"
  name="username"
  autocomplete="username"
  />
  <input
  style="display: none"
  type="password"
  name="old password"
  autocomplete="password"
  />
  <input
  style="display: none"
  type="password"
  name="password"
  autocomplete="new-password"
  />
<div id=login-page  class="primary-background">
  <div id="login-form" class="align-center">
    <nb-card>
      <nb-card-body>
        <img id="school-logo" src="school-assets/school_logo.png" alt="">
        <div id="error-wrapper">
          <scaffold-loading-animation *ngIf="loading"></scaffold-loading-animation>
        </div> 
        <div>
         <div *ngIf="passwordSent">
              <p>{{'password_recovery_instructions_sent'| translation}}</p>
            </div>
          <div class="form-holder" *ngIf="!passwordSent">

            <nb-form-field>
              <label>{{'username'| translation}}</label>
              <input [(ngModel)]="username" nbInput [placeholder]="'username'|translation" [disabled]="loading">
            </nb-form-field>
            <br />
            <div class="button-holder"  *ngIf="!policies">
              <button nbButton (click)=startForgot() [disabled]="username?.length < 1 || loading" >{{'submit_username'| translation}}</button>
            </div>
          </div>
        </div>
        <!--NEBULAR FIX password input handling-->
        <div *ngIf="policies">
          <div class="form-holder">
            <h2>{{'password_new_set'| translation}}</h2>
            <!-- <p>Verification code should have been sent via {{verfifyMethod}}</p> -->
            <nb-form-field>
              <label>{{'verification_code'| translation}}</label>
              <input #code="ngModel" [(ngModel)]="verificationCode" nbInput [placeholder]="'verification_code'|translation" type="text" required />
            </nb-form-field>
            <br />
            <nb-form-field>
              <label>{{'password_new'| translation}}</label>
              <input #newPassword="ngModel" [(ngModel)]="newPw" nbInput [placeholder]="'new_password'|translation" type="password"
                     required
                     [minlength]="policies.MinimumLength"
                     [mustHaveUpercase]="policies.RequireUppercase"
                     [mustHaveLowercase]="policies.RequireLowercase"
                     [mustHaveNumber]="policies.RequireNumbers"
                     mustContainCharacters="{{ policies.RequireSymbols ? COGNITO_SPECAIL_CHARACTER_REGEX : null}}">
            </nb-form-field>
            <br />
            <nb-form-field>
              <label>{{'password_confirm'| translation}}</label>
              <input #confirmPassword="ngModel" [(ngModel)]="confirmPw" nbInput [placeholder]="'password_confirm'| translation" type="password" required mustMatchInput="{{newPw}}">
            </nb-form-field>
            <br />
            <password-strength-meter (strengthChange)="passwordStrength=$event" [minPasswordLength]="policies?.MinimumLength||7" [enableFeedback]="true" [password]="newPw"></password-strength-meter>
            <p><strong>{{'password_requirement'| translation}}</strong></p>
            <p *ngIf="policies?.MinimumLength > 0" [ngClass]="{'strike-through' : newPassword.dirty && (!newPassword.errors || !newPassword.errors.minlength)}">{{'requirement_minimum_length'| translation}} : {{policies.MinimumLength}}</p>
            <p *ngIf="policies?.RequireUppercase" [ngClass]="{'strike-through' : newPassword.dirty && (!newPassword.errors || !newPassword.errors.mustHaveUpercase)}">{{'requirement_uppercase'| translation}}</p>
            <p *ngIf="policies?.RequireLowercase" [ngClass]="{'strike-through' : newPassword.dirty && (!newPassword.errors || !newPassword.errors.mustHaveLowercase)}">{{'requirement_lowercase'| translation}}</p>
            <p *ngIf="policies?.RequireNumbers" [ngClass]="{'strike-through' : newPassword.dirty && (!newPassword.errors || !newPassword.errors.mustHaveNumber)}">{{'requirement_number'| translation}}</p>
            <p *ngIf="policies?.RequireSymbols" [ngClass]="{'strike-through' : newPassword.dirty && (!newPassword.errors || !newPassword.errors.mustHaveSpecialCharacter)}">{{'requirement_special_character'| translation}}: ^ $ * . [ ] {{'{'}} } ( ) ? - " ! @ # % & / \ , > < ' : ; | _ ~ `</p>

            <p class="error-msg" *ngIf="error">{{error}}</p>
            <div class="button-holder">
              <button nbButton routerLink="/login">{{'cancel'| translation}}</button>

              <button nbButton (click)=submitNewPw() color="primary" [disabled]="newPw === '' || newPw !== confirmPw">{{'submit'| translation}}</button>
            </div>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
